import { setExtraFeatures } from "../../client";

/**
 * With this the server tells us which features it supports
 * @param {Array} args list of features
 */
export const handleFL = (args: string[]) => {
  console.info("Server-supported features:");
  console.info(args);
  setExtraFeatures(args);

  if (args.includes("yellowtext")) {
    const colorselect = <HTMLSelectElement>document.getElementById("textcolor");

    colorselect.options[colorselect.options.length] = new Option("Yellow", "5");
    colorselect.options[colorselect.options.length] = new Option("Pink", "6");
    colorselect.options[colorselect.options.length] = new Option("Cyan", "7");
    colorselect.options[colorselect.options.length] = new Option("Grey", "8");
  }

  const show = (...ids: string[]) =>
    ids.forEach((id) => {
      const el = document.getElementById(id);
      if (el) el.style.display = "";
    });

  if (args.includes("cccc_ic_support")) {
    show("cccc_delivery", "cccc_sticky", "cccc_char", "pairing");
  }

  if (args.includes("flipping")) {
    show("button_flip");
  }

  if (args.includes("looping_sfx")) {
    show("button_shake", "2.7");
  }

  if (args.includes("effects")) {
    show("2.8_effect", "2.8_additive");
  }

  if (args.includes("y_offset")) {
    show("y_offset");
  }
};
